import { render, staticRenderFns } from "./groupWrapper.vue?vue&type=template&id=6dbaea92"
import script from "./groupWrapper.vue?vue&type=script&lang=js"
export * from "./groupWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports